export default __webpack_public_path__ + "static/media/impostazioni-dark.14011720.svg";